export const recursiveFetch = async req => {
  const nodes = [];
  
  const rec = async url => {
    const response = await fetch(url);
    const fetchedData = await response.json();
  
    if (fetchedData?.data?.length > 0) {
      nodes.push(...fetchedData.data)
    }
  
    // if the next link exists, recursively fetch next set of data
    if (fetchedData?.links?.next?.href) {
      await rec(fetchedData.links.next.href);
    }
  }

  // initiate recursive function
  await rec(req);

  return nodes;
}
